var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { Controller } from "react-hook-form";
import { Accordion, AccordionSet, Col, ErrorModal, Pane, PaneFooter, Row, Button, Modal, } from "@folio/stripes/components";
import { RecekPaneSet } from "../RecekPaneSet";
import { FormFooterStart } from "../FormFooterStart";
import { FormFooterEnd } from "../FormFooterEnd";
import { ExpandCollapseToggle } from "../ExpandCollapseToggle";
import { FieldRow } from "../FieldRow";
import { RecekSelection } from "../inputs";
import { NewPublisherForm } from "../publisher/NewPublisherForm";
import { useTitleVerificationForm } from "../../hooks/useTitleVerificationForm";
var TitleForVerificationForm = function (_a) {
    var initialValues = _a.initialValues, onSubmit = _a.onSubmit, title = _a.title, onCancel = _a.onCancel;
    var formatMessage = useIntl().formatMessage;
    var _b = useState({
        general: true,
        publishers: true,
    }), accordionStatus = _b[0], setAccordionStatus = _b[1];
    var _c = useState(true), expandAll = _c[0], setExpandAll = _c[1];
    var _d = useState(false), isNewPublisherModalOpen = _d[0], setIsNewPublisherModalOpen = _d[1];
    var _e = useTitleVerificationForm({ initialValues: initialValues }), handleSubmit = _e.handleSubmit, control = _e.control, errors = _e.errors, publisherOptions = _e.publisherOptions, isPublishersLoading = _e.isPublishersLoading, setPublisherQuery = _e.setPublisherQuery, setPublisherId = _e.setPublisherId, errorModalOpen = _e.errorModalOpen, setErrorModalOpen = _e.setErrorModalOpen, errorMessage = _e.errorMessage, setErrorMessage = _e.setErrorMessage, handleErrorModalClose = _e.handleErrorModalClose;
    var handleFormSubmit = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!initialValues.id) {
                        throw new Error("Title detail error: missing title ID");
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, onSubmit(data)];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    setErrorMessage(formatMessage({
                        id: "ui-br-legaldeposits.title.error.pairPublisher",
                    }));
                    setErrorModalOpen(true);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var toggleExpandCollapseAll = function () {
        setAccordionStatus({
            general: !expandAll,
            publishers: !expandAll,
        });
        setExpandAll(!expandAll);
    };
    var handlePublisherCreated = function (publisher) {
        setPublisherId(publisher.id || "", publisher.name || "");
        setIsNewPublisherModalOpen(false);
    };
    return (React.createElement(RecekPaneSet, null,
        React.createElement(Pane, { id: "contentPane", defaultWidth: "fill", paneTitle: title, footer: React.createElement(PaneFooter, { renderStart: React.createElement(FormFooterStart, { handleSubmit: handleSubmit, onSubmit: handleFormSubmit, buttonMessageId: "ui-br-legaldeposits.button.save" }), renderEnd: React.createElement(FormFooterEnd, { onCancel: onCancel, buttonMessageId: "ui-br-legaldeposits.button.cancel" }) }) },
            React.createElement(ErrorModal, { open: errorModalOpen, label: formatMessage({
                    id: "ui-br-legaldeposits.error.modal.title",
                }), content: errorMessage, onClose: handleErrorModalClose }),
            React.createElement(ExpandCollapseToggle, { expanded: expandAll, onToggle: toggleExpandCollapseAll }),
            React.createElement("form", { onSubmit: handleSubmit(handleFormSubmit) },
                React.createElement(AccordionSet, null,
                    React.createElement(Accordion, { label: formatMessage({
                            id: "ui-br-legaldeposits.title.accordion.general",
                        }), open: accordionStatus.general, onToggle: function () {
                            return setAccordionStatus(__assign(__assign({}, accordionStatus), { general: !accordionStatus.general }));
                        } },
                        React.createElement(Row, null,
                            React.createElement(Col, { xs: 12 },
                                React.createElement(FieldRow, { labelId: "ui-br-legaldeposits.title.field.name", value: initialValues.title })),
                            React.createElement(Col, { xs: 12, md: 6 },
                                React.createElement(FieldRow, { labelId: "ui-br-legaldeposits.title.field.author", value: initialValues.author })),
                            React.createElement(Col, { xs: 12, md: 6 },
                                React.createElement(FieldRow, { labelId: "ui-br-legaldeposits.title.field.year", value: initialValues.copyrightFrom })),
                            React.createElement(Col, { xs: 12, md: 6 },
                                React.createElement(FieldRow, { labelId: "ui-br-legaldeposits.title.field.publisherName", value: initialValues.publisherNameToCheck })),
                            React.createElement(Col, { xs: 12, md: 6 },
                                React.createElement(FieldRow, { labelId: "ui-br-legaldeposits.title.field.publisherPlace", value: initialValues.publisherPlaceToCheck })),
                            React.createElement(Col, { xs: 12, md: 6 },
                                React.createElement(FieldRow, { labelId: "ui-br-legaldeposits.title.field.isbn", value: initialValues.isbn })))),
                    React.createElement(Accordion, { label: formatMessage({
                            id: "ui-br-legaldeposits.title.accordion.publishers",
                        }), open: accordionStatus.publishers, onToggle: function () {
                            return setAccordionStatus(__assign(__assign({}, accordionStatus), { publishers: !accordionStatus.publishers }));
                        } },
                        React.createElement(Row, null,
                            React.createElement(Col, { xs: 12, md: 6 },
                                React.createElement(Controller, { control: control, name: "publisherId", render: function (_a) {
                                        var _b;
                                        var field = _a.field;
                                        return (React.createElement(RecekSelection, { labelId: "ui-br-legaldeposits.title.label.publisher", name: "publisherId", value: field.value, asyncFilter: true, loading: isPublishersLoading, onFilter: function (val) { return setPublisherQuery(val); }, onChange: function (id) { return field.onChange(id); }, dataOptions: publisherOptions, error: (_b = errors.publisherId) === null || _b === void 0 ? void 0 : _b.message, marginBottom0: true, required: true, initialFilterValue: initialValues.publisherNameToCheck }));
                                    } }))),
                        React.createElement(Row, null,
                            React.createElement(Col, { xs: 12 },
                                React.createElement("h4", null,
                                    React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.title.separator.or" })))),
                        React.createElement(Row, null,
                            React.createElement(Col, { xs: 12 },
                                React.createElement(Button, { buttonStyle: "primary", onClick: function () { return setIsNewPublisherModalOpen(true); } },
                                    React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.title.button.createNewPublisher" }))))))),
            React.createElement(Modal, { open: isNewPublisherModalOpen, label: formatMessage({
                    id: "ui-br-legaldeposits.title.modal.newPublisher.title",
                }), onClose: function () { return setIsNewPublisherModalOpen(false); }, size: "large" },
                React.createElement(NewPublisherForm, { onCancel: function () { return setIsNewPublisherModalOpen(false); }, onPublisherCreated: handlePublisherCreated, inModal: true })))));
};
export { TitleForVerificationForm };
